import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export const Navbar = ({ onNavigate }) => {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/5"
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-[80px] flex items-center justify-between">
        <button
          onClick={() => onNavigate("#accueil")}
          className="flex items-center gap-3 group"
          data-testid="nav-logo-button"
          aria-label="SLH.PHONE — retour en haut"
        >
          <img
            src="/assets/logo.png"
            alt="Logo SLH.PHONE"
            className="h-12 w-auto mix-blend-screen transition-transform duration-500 group-hover:scale-105"
          />
        </button>

        <nav className="hidden md:flex items-center gap-10" aria-label="Navigation principale">
        </nav>

        <div className="flex items-center gap-4">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            href="tel:+33651487403"
            className="flex items-center gap-2 rounded-full bg-[#0055FF] px-4 py-1.5 text-[10px] font-semibold uppercase tracking-[0.15em] text-white shadow-[0_0_20px_rgba(0,85,255,0.35)] hover:shadow-[0_0_30px_rgba(0,85,255,0.55)] transition-shadow duration-300"
            data-testid="nav-phone-cta"
          >
            <Phone className="h-3 w-3" />
            06 51 48 74 03
          </motion.a>
        </div>
      </div>
    </motion.header>
  );
};
